import { getApiClient } from './api';

const login = async (username, password) => {
  const api = getApiClient();
  try {
    const res = await api({
      method: 'POST',
      url: '/auth/login',
      data: {
        username,
        password,
      },
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

const verifyToken = async (accessToken) => {
  const api = getApiClient();
  try {
    const res = await api({
      method: 'POST',
      url: '/auth/verify',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

const logout = async () => {
  try {
    const api = getApiClient();
    const res = await api({
      method: 'POST',
      url: '/auth/logout',
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

const changePassword = async ({ oldPassword, newPassword }) => {
  try {
    const api = getApiClient();
    const res = await api({
      method: 'POST',
      url: '/auth/change-password',
      data: {
        oldPassword,
        newPassword,
      },
    });

    return res;
  } catch (error) {
    return error.response?.data;
  }
};

export { login, verifyToken, logout, changePassword };
